import styled from 'styled-components'

export const Container = styled.div`
display: flex;
flex-direction: column;
gap: .5rem;
max-width: 34.375rem;
`

export const FlexIcon = styled.div`
display: flex;
margin-bottom: .5rem;
strong{
    color:var(--Red);
    font-size: 14px;
}

svg,h4{
    font-weight: 600;
    margin-bottom: -.3rem;
}

svg{
    margin-right: .5rem;
    min-width: 2.5rem;
    margin-top: .4rem;
    margin-right: .375rem;
}

small{
font-family: 'Roboto','sans-serif';
font-weight: 700;
font-size: 0.875rem;
font-size: 12px;
}
`
